import React from "react";
import Newsletter from "../Newsletter/Newsletter";
import "../../styles/Home.css";
import HeroSection from "../HeroSection/HeroSection";
import Features from "../Features/Features";
import QualityFeatures from "../QualityFeatures/QualityFeatures";
import CoreFeatures from "../CoreFeatures/CoreFeatures";
import SmartJackpot from "../SmartJackpot/SmartJackpot";
import SecurePayment from "../SecurePayment/SecurePayment";
import HowItWorks from "../HowItWorks/HowItWorks";
import Pricing from "../Pricing/Pricing";
import FAQ from "../FAQ/FAQ";
import Testimonial from "../Testimonial/Testimonial";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <Features />
      <CoreFeatures />
      <QualityFeatures />
      <SmartJackpot />
      <HowItWorks />
      <Testimonial />
      <SecurePayment />
      <Pricing />
      <FAQ />
      <Newsletter />
    </div>
  );
};

export default Home;
